// WP3 (audit pwreset-2 / pwreset-6): the login page used to echo raw Firebase
// error strings and claimed "email sent" unconditionally. These two helpers keep
// the copy honest and free of SDK codes.

const GENERIC = "Could not send the reset email. Try again in a moment.";

const RESET_ERROR_COPY: Record<string, string> = {
  "auth/invalid-email": "That does not look like a valid email address.",
  "auth/too-many-requests": "Too many attempts. Wait a few minutes and try again.",
  "auth/network-request-failed": "Could not reach the sign-in service. Check your connection and try again.",
};

/** Human copy for a failed sendPasswordResetEmail call. Never returns an `auth/...` code. */
export function describeResetError(err: unknown): string {
  const code = (err as { code?: unknown } | null | undefined)?.code;
  if (typeof code === "string" && RESET_ERROR_COPY[code]) return RESET_ERROR_COPY[code];
  return GENERIC;
}

/**
 * Where the Firebase-hosted reset handler sends people afterwards. Built from the
 * origin the person is on (production, a preview domain, or localhost are all in
 * Auth's authorized domains) so the "Continue" button lands back in this app.
 */
export function resetContinueUrl(origin: string): string {
  return `${origin.replace(/\/+$/, "")}/login`;
}
